import { render, staticRenderFns } from "./Society.vue?vue&type=template&id=1f8439e1"
import script from "./Society.vue?vue&type=script&lang=js"
export * from "./Society.vue?vue&type=script&lang=js"
import style0 from "./Society.vue?vue&type=style&index=0&id=1f8439e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports